new Swiper(".custom-collection-main-box", {
  slidesPerView: 4,
  spaceBetween: 30,
  pagination: {
    el: '.swiper-paginations',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-nexts',
    prevEl: '.swiper-button-prevs',
  },
  breakpoints: {
    0: {
      slidesPerView: 1.40,
      spaceBetween: 25
    },
    480: {
      slidesPerView: 2,
      spaceBetween: 25
    },
    767: {
      slidesPerView: 3,
      spaceBetween: 25
    },
    1200: {
      slidesPerView: 3.5,
      spaceBetween: 25
    }
  }
});